import * as _ from "lodash"
import {
    WB_EventCustomerRow, WB_EventFRRow, WB_EventProductGroupRow, WB_EventRelationshipRow, WB_EventRow,
    WB_EventSpendPrdGrpRedistribRow,
    WB_EventSpendPrdGrpRow,
    WB_PlanRow, WB_ProductGroupRow
} from '../PA.Core/PAdbSchemaRows';
import {IProgressProvider} from "../PA.Core/PA.Core.IF.Basic";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {PlanBO} from "../PA.TPM.BusinessObjects/PlanBO";
import {EventBO} from "../PA.TPM.BusinessObjects/EventBO"
import {PAdbContext} from "../PA.Core/PAdbContext";


export interface IHavePlan {
    readonly bIHavePlanLoaded: boolean;
    readonly OnIHavePlanLoaded: Promise<IHavePlan>; // triggers the load process...
    readonly Plan: PlanBO
}


export interface IHaveEventsListenerFunction {
    (anObj: IHaveEvents, Action: string, arrEvents: EventBO[], options: any): void
}

export interface IHaveEvents {

    // Initial Loading
    readonly bIHaveEventsLoaded: boolean;
    readonly OnIHaveEventsLoaded: Promise<IHaveEvents>; // triggers the load process...

    // dbContext
    readonly dbContext: PAdbContext

    // Event Load Operations
    pauseLoadProcessing(): void

    resumeLoadProcessing(): void

    resumeLoadProcessingWait(): Promise<void>

    // Event Operations
    hasEvent(aWB_Evt_ID: number): boolean

    getEvent(aWB_Evt_ID: number): EventBO

    addEvent(anEventBO: EventBO): void

    readonly Events: EventBO[]
    readonly EventsChanged: BehaviorSubject<IHaveEvents>

    addChangeListener(aListener: IHaveEventsListenerFunction): void

    removeChangeListener(aListener: IHaveEventsListenerFunction): void


    // Plan Load Scope Operations
    hasPlan(aWBPlanId: number): boolean

    getPlan(aWBPlanId: number): PlanBO

    addPlanBO(aPlanBO: PlanBO): void

    addPlan(aWBPlanId: number): Promise<IHaveEvents>

    readonly Plans: PlanBO[]

    //Load Events
    loadEvents(arrEvtIds: number[]): void

    // Load by Product Groups
    loadAllProductGroups(): void

    loadProductGroups(arrWBPGIds: number[]): void

    readonly ProductGroupsLoaded: WB_ProductGroupRow[]
    readonly ProductGroupsAllLoaded: boolean
    readonly EventLoadProgressProvider: IProgressProvider

    // Helper function to allow BO to determine if we should load everything on create. or let loader do it
    getEventIds(bIncludePGFilter?: boolean): Promise<number[]>

    // Queue Functions
    readonly QueueChanged: BehaviorSubject<IHaveEvents>

    getProductGroupAll(bIncludeQueued?: boolean): boolean

    getProductGroups(bIncludeQueued?: boolean): WB_ProductGroupRow[]

    getPlans(bIncludeQueued?: boolean): WB_PlanRow[]

    getPlanBOs(bIncludeQueued?: boolean): PlanBO[]

    releaseReference() :void

}


export function instanceOfIHaveEvents(obj: any): boolean {
    if ((_.isEmpty(obj)) || (!_.isObject(obj))) {
        return false
    }
    var checkFields = ['bIHaveEventsLoaded', 'OnIHaveEventsLoaded',
        'Events']
    var returnValue = true
    _.forEach(checkFields, (fieldName: string) => {
        if (!(fieldName in obj)) {
            returnValue = false
            return false
        }
    })
    return returnValue
}


export interface IEventChangedEvent {
    EventBO: EventBO,
    Row: WB_EventRow,
    PropertyChanged: string,
    PropertyValue: any
}

export interface IEvent {
    // Fire when WB_EventRow or WB_EventOverrideRow changes.
    readonly EventPropertyChanged: BehaviorSubject<IEventChangedEvent>;
}


export interface IEventProductGroupAddOptions {
    FinishedProductsIds?: number[]
}

export interface IEventProductGroupChangedEvent {
    EventBO: EventBO,
    Row: WB_EventProductGroupRow,
    PropertyChanged: string,
    PropertyValue: any
}


export interface IEventProductGroup {

    // TODO: Change the add to return Promise<{EventBO: EventBO, Row: EventPG })
    addEventProductGroup(WB_PrdGrp_ID: number, options: IEventProductGroupAddOptions): Promise<EventBO>;

    removeEventProductGroup(WB_PrdGrp_ID: number): Promise<EventBO>;

    // Fire when the above changes
    readonly ProductGroupCollectionChanged: BehaviorSubject<EventBO>;

    // Fire when WB_EventProductGroupRow or OverrideRow changes
    readonly ProductGroupPropertyChanged: BehaviorSubject<IEventProductGroupChangedEvent>;

}

export interface IEventSourceCustomerAddOptions {
}


export interface IEventSourceCustomerChangedEvent {
    EventBO: EventBO,
    Row: WB_EventCustomerRow,
    PropertyChanged: string,
    PropertyValue: any
}

export interface IEventSourceCustomer {

    addEventSourceCustomer(WB_Cust_ID: number, options: IEventSourceCustomerAddOptions): Promise<EventBO>;

    removeEventSourceCustomer(WB_Cust_ID: number): Promise<EventBO>;


    readonly SourceCustomerCollectionChanged: BehaviorSubject<EventBO>;

    readonly SourceCustomerPropertyChanged: BehaviorSubject<IEventSourceCustomerChangedEvent>;

}


export interface IEventSpendAddOptions {
    DealStartDt?: Date,
    DealEndDt?: Date,
    WB_SpendM_Id?: number,
    RateBasisID?: string,
    RateUOM?: string,
    RateAmt?: number,
    RateAmtPerUnit?: number,
    PaymentMethodId?: number,
    SpendCalcMethod?: string,
    MarginalInd?: boolean,
    FinishedProductsIds?: number[]

}

export interface IEventSpendChangedEvent {
    EventBO: EventBO,
    Row: WB_EventSpendPrdGrpRow,
    PropertyChanged: string,
    PropertyValue: any
}


export interface IEventSpend {

    addEventSpend(WB_PrdGrp_ID: number, options: IEventSpendAddOptions): Promise<EventBO>;

    removeEventSpend(WB_EvtSPG_ID: number): Promise<EventBO>;

    // Fire when the above changes
    readonly SpendPropertyChanged: BehaviorSubject<IEventSpendChangedEvent>;
    readonly SpendCollectionChanged: BehaviorSubject<EventBO>;

}

export interface IEventRedistributedSpendAddOptions {
    AllocationBasisId?: number,
    AllocationBasisRate?: number,
    AllocationRuleId?: number,
    WB_PrdGrp_ID?: number,
    bSkipNotification?: boolean,
    bManual?: boolean
}

export const IEventRedistributedSpendAddOptionsDefault: IEventRedistributedSpendAddOptions = {
    AllocationBasisRate: 0,
    bSkipNotification: false,
    bManual: true
}


export interface IEventRedistributedSpendRemoveOptions {
    bSkipNotification?: boolean
}

export const IEventRedistributedSpendRemoveOptionsDefault: IEventRedistributedSpendRemoveOptions = {
    bSkipNotification: false
}

export interface IEventRedistributedSpendAutoAnchorOptions {
}

export const IEventRedistributedSpendAutoAnchorOptionsDefault: IEventRedistributedSpendAutoAnchorOptions = {}

export interface IEventRedistributedSpendSyncOptions {
    AllocationBasisId?: number,
    AllocationRuleId?: number
}

export const IEventRedistributedSpendSyncOptionsDefault: IEventRedistributedSpendSyncOptions = {}


export interface IEventRedistributedSpendChangedEvent {
    EventBO: EventBO,
    Row: WB_EventSpendPrdGrpRedistribRow,
    PropertyChanged: string,
    PropertyValue: any
}

export interface IEventRedistributedSpend {

    addEventRedistributedSpend(WB_EvtSPG_ID: number, options?: IEventRedistributedSpendAddOptions): Promise<EventBO>;

    removeEventRedistributedSpend(WB_EvtRSPG_ID: number, options?: IEventRedistributedSpendRemoveOptions): Promise<EventBO>;

    // For the Overlap Processor
    syncOverlappingRedistributedSpend(options?: IEventRedistributedSpendAutoAnchorOptions): Promise<EventBO>;

    syncOverlappingEventRedistributedSpend(arrWB_EvtSPG_ID: number[], options?: IEventRedistributedSpendSyncOptions): Promise<EventBO>;

    addManualEventRedistributedSpend(anEventBO: EventBO, options?: IEventRedistributedSpendAddOptions): Promise<EventBO>

    // Fire when the above changes
    readonly RedistributedSpendPropertyChanged: BehaviorSubject<IEventRedistributedSpendChangedEvent>;
    readonly RedistributedSpendCollectionChanged: BehaviorSubject<EventBO>;

}

export interface IHaveEventParentRelationship {
    readonly EventParent: WB_EventRelationshipRow
  setParent(wbEventId: number): Promise<WB_EventRelationshipRow>
    removeParent(): Promise<IHaveEventParentRelationship>

    readonly EventChildren: WB_EventRelationshipRow[]
    readonly EventParentRelationshipsChanged: BehaviorSubject<IHaveEventParentRelationship>
}

export interface IEventFundingChangedEvent {
    EventBO: EventBO,
    Row: WB_EventFRRow,
    PropertyChanged: string,
    PropertyValue: any
}

export interface IHaveEventFunding {
    readonly EventFundingChildren: WB_EventFRRow[]
    readonly EventFundingCollectionChanged: BehaviorSubject<IHaveEventFunding>
    readonly EventFRPropertyChanged: BehaviorSubject<IEventFundingChangedEvent>;

    addEventFundingChild(aSourceRow:WB_EventRow ): Promise<WB_EventFRRow>
    removeEventFundingChild(wbERId:number):  Promise<IHaveEventFunding>
}